import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import ToMainMenuButton from '@ts-core/components/ToMainMenuButton';
import { useCourseStats } from '@ts-core/modules/courses/hooks';

import { SubjectWithStats } from 'modules/subjects/types/stats';

import { courseStatsFragment } from '../../graphql/fragments';
import { CourseStats } from '../../types/stats';

import CourseStatsTable from '../../components/CourseStatsTable/CourseStatsTable';

const CourseStatsPage = () => {
  const { courseId } = useParams<{ courseId: string }>();
  const intl = useIntl();
  const history = useHistory();
  const { loading, onRefetchStats, error, stats } = useCourseStats<CourseStats>({ fragment: courseStatsFragment, courseId });

  const handleSelectSubject = useCallback(
    (subject: SubjectWithStats) => {
      history.push(`/${courseId}/stats/subjects/${subject.id}`);
    },
    [history, courseId]
  );

  return (
    <>
      <ToMainMenuButton title={intl.formatMessage({ id: 'quickLink.courseStats' })} />
      <Box mt={2}>
        <CourseStatsTable
          loading={loading}
          subjects={stats?.subjects}
          error={error}
          onRefetchStats={onRefetchStats}
          onSelectSubject={handleSelectSubject}
        />
      </Box>
    </>
  );
};

export default CourseStatsPage;
